var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.currentTerms),function(company,index){return _c('div',{key:index},[_c('input',{attrs:{"type":"radio"},domProps:{"value":_vm.value,"checked":_vm.value === company},on:{"input":function($event){return _vm.$emit('input', company)}}}),_vm._v(" "+_vm._s(company.toUpperCase())+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-176a81ff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trg/Project/RadioCompaniesDocuments.vue
// module id = V9P6
// module chunks = 10